import * as React from "react";
import styles from "../components/LeftNavigation/DesignerControls/BasicControls.module.css"

function AddColumnIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="11.5" height="11.5" viewBox="0 0 11.5 11.5"><defs></defs><g transform="translate(-468.545 -67.25)"><path className={styles.addColumnIcon} d="M-2226.408,19990v10" transform="translate(2700.702 -19922)"/><path className={styles.addColumnIcon} d="M0,0V10" transform="translate(479.295 73) rotate(90)"/></g></svg>

  );
}

export default AddColumnIcon;